export const faqs = [
    {
        question: 'What is Smart Farm Tools?',
        answer: 'AI powered solutions to plant crop dieseas',
    },
    {
        question: 'Who is it meant for?',
        answer: 'Farmers and agricutural experts',
    },
    {
        question: 'Is it free?',
        answer: 'We have suppport for free packages and exclusive paid packages',
    },
    {
        question: 'Can I meet other farmers here?',
        answer: 'Yes',
    },
    {
        question: 'Will the Botanists help me with my farm?',
        answer: 'Yes',
    },
]
